// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPost, BASE_URL, retrieveToken } from "../../store/api";
import { StatusKerjasamaCreateResponse } from "./types";

import * as statusKerjasamaActions from "./statusKerjasama.actions";
import { showModal } from "../modal/modal.actions";

export function* createStatusKerjasama(
  action: ReturnType<typeof statusKerjasamaActions.createStatusKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'status-kerjasama';
    const result: Response = yield call(apiPost, url, token, action.payload);

    if (result.status === 201) {
      const parsed: StatusKerjasamaCreateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(statusKerjasamaActions.createStatusKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(statusKerjasamaActions.createStatusKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Terjadi kesalahan pada server', 'Silahkan coba kembali dalam beberapa saat'));
    yield put(statusKerjasamaActions.createStatusKerjasamaAsync.failure(parsed));
  }
}

export default function* statusKerjasamaSagaCreateStatusKerjasama() {
  yield takeEvery(statusKerjasamaActions.createStatusKerjasamaAsync.request, createStatusKerjasama);
}
